import Image from 'next/image'
import React, { useContext } from 'react'
import { AnimatePresence, motion } from "framer-motion";
import { BASE_URL } from '../../utils/FetchData';
import { isMobileContext } from '../../contexts/isMobileContext';
const CollaborationsCard = ({ cardData, index }) => {
    const { isMobile } = useContext(isMobileContext);
    return (
            <div className='collabration-card _eleX'>
                <div className='big-img'>
                {cardData?.Img_Mobile?.data?.attributes?.url&&<Image
                        src={`${BASE_URL}${isMobile ? cardData?.Img_Mobile?.data?.attributes?.url : cardData?.Img_Desktop?.data?.attributes?.url}`}
                        alt={isMobile ? cardData?.Img_Mobile?.data?.attributes?.name : cardData?.Img_Desktop?.data?.attributes?.name}
                        objectFit="cover"
                        layout='fill'
                    />}
                </div>
                <div className='card-data'>
                    <div className='logo-container'>
                    {cardData?.Logo?.data?.attributes?.url&&<Image
                        src={`${BASE_URL}${cardData?.Logo?.data?.attributes?.url}`}
                        alt={cardData?.Logo?.data?.attributes?.name}
                        objectFit="cover"
                        layout='fill'
                    />}
                    </div>
                    <div className='title light'>{cardData?.Title}</div>
                    <div className='description'>{cardData?.Description}</div>
                </div>
            </div>
    )
}

export default CollaborationsCard